export default function MaterialIcon({
  name,
  className = '',
  filled = false,
  weight = 400,
  grade = 0,
  opsz = 24,
}) {
  return (
    <span
      className={`material-symbols-outlined ${className}`.trim()}
      style={{
        fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' ${weight}, 'GRAD' ${grade}, 'opsz' ${opsz}`,
      }}
      aria-hidden="true"
    >
      {name}
    </span>
  );
}
